<div class="entity-log">
  <procure-table
    class="hubs__table"
    [dataSourceLength]="dataSourceTotalLength"
    [dataSourceTotalLength]="dataSourceTotalLength"
    [hidePagination]="dataSourceTotalLength < 10"
  >
    <table
      class="entity-log__table"
      aria-label="Status Transitions"
      mat-table
      matSort
      matSortActive="date"
      matSortDirection="desc"
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="fromState">
        <th
          *matHeaderCellDef
          class="entity-log__column--fromState"
          mat-header-cell
          mat-sort-header
        >
          From State
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          <procure-status-badge [status]="entity.previousStatus" />
        </td>
      </ng-container>
      <ng-container matColumnDef="toState">
        <th
          *matHeaderCellDef
          class="entity-log__column--toState"
          mat-header-cell
          mat-sort-header
        >
          To State
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          <procure-status-badge [status]="entity.nextStatus" />
        </td>
      </ng-container>
      <ng-container matColumnDef="responsible">
        <th
          *matHeaderCellDef
          class="entity-log__column--responsible"
          mat-header-cell
          mat-sort-header
        >
          Responsible
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.responsible }}
        </td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th
          *matHeaderCellDef
          class="entity-log__column--date"
          mat-header-cell
          mat-sort-header
        >
          Date (UTC)
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.date | date: "short" }}
        </td>
      </ng-container>
      <tr *matNoDataRow>
        <td [attr.colspan]="displayedColumns.length">There are no status transitions for this entity.</td>
      </tr>
      <tr
        *matHeaderRowDef="displayedColumns"
        mat-header-row
      ></tr>
      <tr
        *matRowDef="let row; columns: displayedColumns"
        mat-row
      ></tr>
    </table>
  </procure-table>
</div>
